export default {"src":"/_next/static/media/pentest-management.4a7988a0.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};